import React from 'react';

import style from './style.module.scss';

type SubNavProps = {
  right?: React.ReactNode;
  left?: React.ReactNode;
  className?: string;
};

const SubNav: React.FunctionComponent<SubNavProps> = ({ right, left, className }) => {
  return (
    <div className={`${style.sub_nav} d-flex align-items-center px-3 py-2 ${className}`}>
      {left}
      {right}
    </div>
  );
};

export default SubNav;
